import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'

import './proceed-upload-modal.css'

class ProceedUploadModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const { showModal, hideModal, handleAccept } = this.props

    return (
      <Modal show={showModal} onHide={hideModal}>
        <Modal.Body>
          <div className='br-proceed-upload'>
            <span
              className='glyphicon glyphicon-exclamation-sign'
              aria-hidden='true'
            />
            <div style={{ marginTop: ' 20px' }}>
              Once you've selected a master mosaic image, you'll only
              <br />
              be able to change this image by creating a new experience.
            </div>
            <div>
              <h3>Proceed and upload image?</h3>
            </div>
            <div>
              <Button className='btn green-haze' onClick={handleAccept}>
                Yes
              </Button>
              <Button className='btn red-haze' onClick={hideModal}>
                No
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

ProceedUploadModal.propTypes = {
  showModal: PropTypes.bool,
  hideModal: PropTypes.func,
  handleAccept: PropTypes.func
}

export default ProceedUploadModal



// WEBPACK FOOTER //
// ./src/components/form/proceed-upload-modal/index.js